export class AlertMessageModel {
  type!: string;
  title!: string;
  messages!: string[];
}